import React from 'react';
import type WorkflowNavigationSettingsType from '@atlassian/jira-spa-apps-project-settings-workflow-navigation/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyWorkflowNavigationSettings = lazyForPaint<typeof WorkflowNavigationSettingsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-workflow-navigation", jiraSpaEntry: "async-project-settings-workflow-navigation" */ '@atlassian/jira-spa-apps-project-settings-workflow-navigation'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyWorkflowNavigationSettings}
		pageId="project-settings-workflow-navigation"
		shouldShowSpinner={false}
	/>
);
